import React from "react";
import { useTranslation } from "react-i18next";

import { Avatar,Button, Typography, MenuItem } from "@mui/material";
import { ArrowForwardIosRounded, KeyboardArrowDownRounded } from "@mui/icons-material";

import { LocaleSwitcher, MenuWithArrow } from "components/common/index";
import { sbiEntities, ENTITY_KEY, isSbi } from "constants/globals";
import BaseHeader from "./BaseHeader";
import useMenuState from "hooks/useMenuState";
import { getEnvVarsStorage } from "helpers";
import { signInBtn } from "./styles";

const updateAuthUrl = (selectedCountry: string, currentUrl: string) => {
  return currentUrl.replace("provider", `${selectedCountry}Provider`);
};

const Header: React.FC = () => {
  const { t } = useTranslation(["common", "auth"]);

  const envs = getEnvVarsStorage();
  const [anchorEl, handleClick, handleClose] = useMenuState();

  const handleCountryEntityClick = (e: React.MouseEvent<HTMLElement>) => {
    const id = (e.target as HTMLInputElement).id;
    localStorage.setItem(ENTITY_KEY, id);
    const authUrl = updateAuthUrl(id, envs?.authUrl);
    window?.location?.replace(authUrl);
  };

  return (
    <BaseHeader>
      <div>
        <LocaleSwitcher />
        <Typography component="span" color="text.primary" sx={{ mx: "7px" }}>
          {t("alreadyHave", { ns: "auth" })}
        </Typography>
        <>
          {isSbi(envs?.tenantName) ? (
            <>
              <Button
                size="small"
                sx={{ color: "text.primary", ml: "10px" }}
                endIcon={<KeyboardArrowDownRounded />}
                onClick={handleClick}
              >
                {"Sign In"}
              </Button>
              <MenuWithArrow anchorEl={anchorEl} onClose={handleClose} onClick={handleClose}>
                {sbiEntities.map(({ label, value }) => {
                  return (
                    <MenuItem id={value} key={value} onClick={handleCountryEntityClick}>
                      <Avatar
                       sx={{ width: 24, height: 24, mr: "10px" }}
                       src={`/images/flags/Country=${value}.svg`}
                      />
                      {label}
                    </MenuItem>
                  );
                })}
              </MenuWithArrow>
            </>
          ) : (
            <Button
              sx={signInBtn}
              variant="outlined"
              size="small"
              endIcon={<ArrowForwardIosRounded />}
              href={envs?.authUrl}
            >
              {t("buttons.signIn")}
            </Button>
          )}
        </>
      </div>
    </BaseHeader>
  );
};

export default Header;
